module.exports = __webpack_public_path__ + "img/ch.696f71d2.svg";